export default () => {
  const modal = document.querySelector('[data-shoppable-image-modal]');

  if (modal) {
    const modalImage = modal.querySelector('[data-shoppable-modal-image]');
    if (modalImage) {
      modalImage.innerHTML = '';
      modalImage.style.backgroundColor = '';
    }

    const modalProducts = modal.querySelector('[data-shoppable-modal-products]');
    if (modalProducts) {
      modalProducts.innerHTML = '';
    }
  }
};
